import { type User, UserManager, type UserProfile } from "oidc-client-ts";

export type OidcUserState = {
	psuId: string;
	accountId: string;
};

export type OidcUser = User & {
	profile: UserProfile & { ssn?: string };
	state: OidcUserState;
};

export type UserSettings = {
	authority: string;
	client_id: string;
	redirect_uri: string;
	response_type: string;
	post_logout_redirect_uri?: string;
	scope?: string;
};

const addListener = (listener: (msg: MessageEvent) => void) =>
	window.addEventListener("message", listener, false);
const removeListener = (listener: (msg: MessageEvent) => void) =>
	window.removeEventListener("message", listener);

const handleMessage = (msg: MessageEvent) => {
	const targetOrigin = userManager?.settings.authority;
	if (msg.origin !== targetOrigin) {
		return false;
	}
	if (msg.data === "changed") {
		handleLogout(handleMessage);
	}
	return false;
};

let userManager: UserManager | null = null;

const initUserManager = (settings: UserSettings) => {
	userManager = new UserManager(settings);
	addListener(handleMessage);
	return userManager;
};

export const getUserManager = (settings?: UserSettings) => {
	if (!settings) {
		if (!userManager) throw new Error("No user manager available. Pass settings to create new.");
		return userManager;
	}

	return userManager || initUserManager(settings);
};

const handleLogout = (listener: (msg: MessageEvent) => void) => {
	userManager?.removeUser().then(() => {
		removeListener(listener);
	});
};
